import { Card, Image, List, Menu } from "antd";
import { observer } from "mobx-react";
import React, { Component } from "react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import config from "../config";

class TrackingMenus extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      items: [],
      remaining: [],
    };
    this.handleMenuClick = this.handleMenuClick.bind(this);
  }

  handleMenuClick = (items) => {
    // const clickedItem = this.findMenuItem(this.state.remaining, items.key);
    // const label = clickedItem ? clickedItem.label : "";
    this.props.navigate("/" + items);
    // this.props.updateTitle(label);
    this.props.closeMenu();
  };

  findMenuItem = (menuItems, key) => {
    for (const item of menuItems) {
      if (item.key === key) return item;
      if (item.children) {
        const found = this.findMenuItem(item.children, key);
        if (found) return found;
      }
    }
    return null;
  };

  async componentDidMount() {
    const items = [
      {
        key: "info",
        type: "group",
        label: (
          <div
            style={{
              padding: "15px",
              color: "#fff",
              backgroundColor: "#002766",
            }}
          >
            <span
              className="menu-items-title"
              style={{
                gap: 10,
              }}
            >
              <img
                src={require("../assets/images/NewDesign/geo-fill.png")}
                alt="Masters"
                style={{ width: "22px" }}
              />
              {this.context.translate("_TRACKING_")}
            </span>

            <p
              style={{
                fontSize: "10px",
                marginTop: "5px",
                color: "rgba(255, 255, 255, 0.8)",

                marginBottom: "0px",
              }}
            >
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_TRACKING_TITLE_")}
            </p>
          </div>
        ),
      },
    ];

    const remaining2 = [
      {
        key: "livetracking",
        type: "livetracking",
        label: (
          <div onClick={() => this.handleMenuClick("livetracking")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/geo-alt-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_LIVE_TRACING_")}
            </span>

            <p
              className="submenu-items-desc"
            // style={{
            //   fontSize: "10px",
            //   marginTop: "10px",
            //   color: "rgba(0, 0, 0, 0.8)",
            //   marginBottom: "0px",
            //   textWrap: "auto",
            //   lineHeight: "normal",
            // }}
            >
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_LIVE_TRACKING_TITILE_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "trackbygroup",
        type: "trackbygroup",
        label: (
          <div onClick={() => this.handleMenuClick("trackbygroup")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/pin-map-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_TRACK_BY_GROUP_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_TRACK_BY_GROUP_TITILE_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "multitracking",
        type: "multitracking",
        label: (
          <div onClick={() => this.handleMenuClick("multitracking")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/cursor-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_MULTI_TRACKING_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_MULTITRACKING_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "liveroutepath",
        type: "liveroutepath",
        label: (
          <div onClick={() => this.handleMenuClick("liveroutepath")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/geo-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_LIVE_ROUTE_PATH_")}
            </span>

            <p
              className="submenu-items-desc"
            // style={{
            //   fontSize: "10px",
            //   marginTop: "10px",
            //   color: "rgba(0, 0, 0, 0.8)",
            //   marginBottom: "0px",
            //   textWrap: "auto",
            //   lineHeight: "normal",
            // }}
            >
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_LIVE_ROUTE_PATH_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "AdvanceDashboard",
        type: "AdvanceDashboard",
        label: (
          <div onClick={() => this.handleMenuClick("AdvanceDashboard")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/pie-chart-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_ADVANCE_DASHBOARD_")}
            </span>

            <p
              className="submenu-items-desc"
            // style={{
            //   fontSize: "10px",
            //   marginTop: "10px",
            //   color: "rgba(0, 0, 0, 0.8)",
            //   marginBottom: "0px",
            //   textWrap: "auto",
            //   lineHeight: "normal",
            // }}
            >
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_ADVANCE_DASHBOARD_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "detailtracking",
        type: "detailtracking",
        label: (
          <div onClick={() => this.handleMenuClick("detailtracking")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/compass-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_DETAIL_TRACKING_")}
            </span>

            <p
              className="submenu-items-desc"
            // style={{
            //   fontSize: "10px",
            //   marginTop: "10px",
            //   color: "rgba(0, 0, 0, 0.8)",
            //   marginBottom: "0px",
            //   textWrap: "auto",
            //   lineHeight: "normal",
            // }}
            >
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_DETAIL_TRACKING_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "heatmap",
        type: "heatmap",
        label: (
          <div onClick={() => this.handleMenuClick("heatmap")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/geo-alt-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_HEAT_MAP_")}
            </span>

            <p
              className="submenu-items-desc"
            // style={{
            //   fontSize: "10px",
            //   marginTop: "10px",
            //   color: "rgba(0, 0, 0, 0.8)",
            //   marginBottom: "0px",
            //   textWrap: "auto",
            //   lineHeight: "normal",
            // }}
            >
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_HEAT_MAP_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "temperaturedashboard",
        type: "temperaturedashboard",
        label: (
          <div onClick={() => this.handleMenuClick("temperaturedashboard")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/Union-1.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_TEMPERATURE_DASHBOARD_")}
            </span>

            <p
              className="submenu-items-desc"
            // style={{
            //   fontSize: "10px",
            //   marginTop: "10px",
            //   color: "rgba(0, 0, 0, 0.8)",
            //   marginBottom: "0px",
            //   textWrap: "auto",
            //   lineHeight: "normal",
            // }}
            >
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_TEMPERATURE_DASHBOARD_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "dashboard",
        type: "dashboard",
        label: (
          <div onClick={() => this.handleMenuClick("dashboard")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/bar-chart-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_DASHBOARD_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_DASHBOARD_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "maintenancedashboard",
        type: "maintenancedashboard",
        label: (
          <div onClick={() => this.handleMenuClick("maintenancedashboard")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/tools.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_MAINTENANCE_DASHBOARD_")}
            </span>

            <p
              className="submenu-items-desc"
            // style={{
            //   fontSize: "10px",
            //   marginTop: "10px",
            //   color: "rgba(0, 0, 0, 0.8)",
            //   marginBottom: "0px",
            //   textWrap: "auto",
            //   lineHeight: "normal",
            // }}
            >
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_MAINTENANCE_DASHBOARD_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "historytracking",
        type: "historytracking",
        label: (
          <div onClick={() => this.handleMenuClick("historytracking")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/Union.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_HISTORY_TRACKING_")}
            </span>

            <p
              className="submenu-items-desc"
            // style={{
            //   fontSize: "10px",
            //   marginTop: "10px",
            //   color: "rgba(0, 0, 0, 0.8)",
            //   marginBottom: "0px",
            //   textWrap: "auto",
            //   lineHeight: "normal",
            // }}
            >
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_HISTORY_TRACKING_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "sensorreportlist",
        type: "sensorreportlist",
        label: (
          <div onClick={() => this.handleMenuClick("sensorreportlist")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/broadcast.png")}
                // alt="Masters"
                style={{ width: "16px" }}
              />
              {this.context.translate("_SENSOR_REPORT_")}
            </span>

            <p
              className="submenu-items-desc"
            // style={{
            //   fontSize: "10px",
            //   marginTop: "10px",
            //   color: "rgba(0, 0, 0, 0.8)",
            //   marginBottom: "0px",
            //   textWrap: "auto",
            //   lineHeight: "normal",
            // }}
            >
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_SENSOR_REPORT_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "warehousemonitoring",
        type: "warehousemonitoring",
        label: (
          <div onClick={() => this.handleMenuClick("warehousemonitoring")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/house-door-fill.png")}
                // alt="Masters"
                style={{ width: "16px" }}
              />
              {this.context.translate("_WAREHOUSE_MONITORING_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_WAREHOUSE_MONITORING_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "videomonitoring",
        type: "videomonitoring",
        label: (
          <div onClick={() => this.handleMenuClick("videomonitoring")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/camera-video-fill.png")}
                // alt="Masters"
                style={{ width: "16px" }}
              />
              {this.context.translate("_VIDEO_MONITORING_")}
            </span>

            <p
              className="submenu-items-desc"
            // style={{
            //   fontSize: "10px",
            //   marginTop: "10px",
            //   color: "rgba(0, 0, 0, 0.8)",
            //   marginBottom: "0px",
            //   textWrap: "auto",
            //   lineHeight: "normal",
            // }}
            >
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_VIDEO_MONITORING_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "multivideomonitoring",
        type: "multivideomonitoring",
        label: (
          <div onClick={() => this.handleMenuClick("multivideomonitoring")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/collection-play-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_MULTI_VIDEO_MONITORING_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_MULTI_VIDEO_MONITORING_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },

      {
        key: "videomonitoring",
        type: "videomonitoring",
        label: (
          <div onClick={() => this.handleMenuClick("evidence")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/camera-video-fill.png")}
                // alt="Masters"
                style={{ width: "16px" }}
              />
              {this.context.translate("_EVIDENCE_")}
            </span>

            <p className="submenu-items-desc">
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_EVIDENCE_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "aiDashboard",
        type: "aiDashboard",
        label: (
          <div onClick={() => this.handleMenuClick("aiDashboard")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/camera-video-fill.png")}
                // alt="Masters"
                style={{ width: "16px" }}
              />
              {this.context.translate("_AI_DASHBOARD_")}
            </span>

            <p className="submenu-items-desc">
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_EVIDENCE_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
    ];

    var remaining = [];
    for (var i = 0; i < remaining2.length; i++) {
      //console.log(remaining2[i].key);
      if (this.props.trackingManagement.includes(remaining2[i].key)) {
        remaining.push(remaining2[i]);
      }
    }
    this.setState({ items: items, remaining: remaining });
  }

  render() {
    return (
      <div
        className="tracking-menu-items"
        style={{
          width: Number(config.showMenuDescription) == 0 ? "500px" : "750px",
        }}
      >
        <div className="tracking-menu-items-list">
          <Menu
            style={{
              // height: "90vh",
              border: "none",
              scrollbarWidth: "none",
              overflow: "scroll",
              // boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
            }}
            items={this.state.items}
          />
        </div>
        <div
          className="tracking-submenu-items-list"
        // style={{
        //   overflow: "scroll",
        //   boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
        //   height: "75vh",
        //   scrollbarWidth: "none",
        // }}
        >
          <Menu
            className="tracking-list-menu"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              border: "none",
              scrollbarWidth: "none",
              overflow: "scroll",
              boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
              // align-content: flex-start;
              alignContent: "flex-start",
              height: "100%",
            }}
            items={this.state.remaining}
            onMouseLeave={() => this.props.closeMenu()}
          // onClick={(items) => this.handleMenuClick(items)}
          />
        </div>
      </div>
    );
  }
}

TrackingMenus.contextType = StoreContext;
export default observer(withRouter(TrackingMenus));
